import { apiGet, apiUpdate } from "../../API/Service/apiClient";

export const handleCategory_Get =
 async({setCategoryOptions,setSelectedOption}) => {
   
  try {         
    const resData = await apiGet("category", {});        
    const options = resData?.data?.map((cat) => ({
      value: cat.id,
      label: cat.catgname
    }));
    setCategoryOptions(options)
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    
  }
}

export const handleMainProduct_Get =
 async({setItems,selectedOption,setLoading}) => {
  setLoading(true)  
  try {         
    let data={
      catgid:selectedOption?.value
    }
    const resData = await apiGet("mainproduct",data);        
    const sortedCategories = resData?.data?.sort((a, b) => a.mp_seqno - b.mp_seqno);
    setItems(sortedCategories);
     
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false)
  }
}

export const handleSubmit = async ({items,setIsLoading,setIsChanged}) => {
  setIsLoading(true);
  try {     
    let data={
      categories: items.map((item, index) => ({ id: item.id, seqno: index })),
      action: "reorder",
    }
    const resData = await apiUpdate("mainproduct",data);
    alert("Order saved successfully!");
    setIsChanged(false);
  } catch (error) {
    console.error("Error saving order", error);
  } finally {
    setIsLoading(false);
  }
};